import { BLOCK_TYPES as i } from "./constants.js";
class s {
  blocks;
  stepsSinceLastChange;
  constructor(t = [], e = []) {
    this.blocks = t, this.stepsSinceLastChange = e;
  }
  get onlyAttachmentListBlock() {
    return this.blocks.find((t) => t.type === i.ATTACHMENT_LIST);
  }
  get excludingAttachmentListBlock() {
    return new s(
      this.blocks.filter((t) => t.type !== i.ATTACHMENT_LIST),
      this.stepsSinceLastChange
    );
  }
  equals(t) {
    return t === this || JSON.stringify(t.blocks) === JSON.stringify(this.blocks);
  }
  append(t) {
    return t ? new s(this.blocks.slice(0).concat(t), this.stepsSinceLastChange) : new s(this.blocks.slice(0), this.stepsSinceLastChange);
  }
  appendMultiple(t) {
    const e = t.filter((n) => n !== null && typeof n !== "undefined");
    return e.length > 0 ? new s(
      this.blocks.slice(0).concat(e),
      this.stepsSinceLastChange
    ) : new s(this.blocks.slice(0), this.stepsSinceLastChange);
  }
}
export {
  s as BlocksDocument
};
